import React, { useEffect, useState, useContext, useCallback } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card, RightAlignedButton } from "../../common_components/Layout";
import { TitleAndText } from "./TitleAndText";
import CreationFooter from "./CreationFooter";
import { useAlert } from 'react-alert'
import AvailabilityCalendar from "./AvailabilityCalendar";
import { PrimaryButton } from "../../common_components/Buttons";
import DateFormatting from "../../common_components/DateFormatting";
import CreateMissionHeaderAndTitleRow from "./CreateMissionHeaderAndTitleRow";
const { DateTime } = require('luxon');
import _ from 'lodash'; // Lodash for debouncing




// Api Calls
import MissionEventsAPI from "../../../api/api_calls/MissionEventsAPI";



function Scheduling(props) {


    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [submitInProcess, setSubmitInProcess] = useState(false);

    const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone); // Save the timezone in state
    const [notice, setNotice] = useState(24);
    const [buffer, setBuffer] = useState(15);
    const [missionLength, setMissionLength] = useState(-1);

    const [loadingMissionEvent, setLoadingMissionEvent] = useState(true);
    const [selectedSlots, setSelectedSlots] = useState(new Set());

    const [price, setPrice] = useState("-");
    const [totalPrice, setTotalPrice] = useState("-");

    function updatePriceWrapper() {
        updatePrice(setPrice, setTotalPrice, missionId, navigate, alert);
    }


    useEffect(() => {

        // NEXT UP - GET THE INITIAL TIMEZONE, BUFFER, and NOTICE FROM THE BACKEND
        // Also, get the current selected availability from the backend.

        async function getMissionEvents() {
            const result = await MissionEventsAPI.index(missionId, navigate);

            if (result.success) {
                if (result.mission_event) {
                    // Update to use && syntax next time
                    if (result.mission_event.timezone) { setTimezone(result.mission_event.timezone) };
                    if (result.mission_event.minimum_booking_notice_in_milliseconds) { setNotice(result.mission_event.minimum_booking_notice_in_milliseconds / 1000 / 60 / 60) };
                    if (result.mission_event.buffer_length_in_milliseconds) { setBuffer(result.mission_event.buffer_length_in_milliseconds / 1000 / 60) };
                    if (result.mission_event.appointment_length_in_milliseconds) { setMissionLength(result.mission_event.appointment_length_in_milliseconds / 1000 / 60) };
                    if (result.mission_event_availabilities) {
                        const tempTimezone = result.mission_event.timezone;
                        // For each availability, we want to add it to our availabilities list
                        // if the following conditions are met:
                        // The availability is in the future
                        // availability.reserved = false
                        // Format the date and time to match slot style in TimeGrid. Gross, oh well.
                        // Filter out any null values
                        const tempAvailabilities = result.mission_event_availabilities.map((availability) => {
                            if (availability.reserved == false && (DateFormatting.parseStringWithTimezone(availability.start_time, tempTimezone) > DateTime.now())) {
                                return DateFormatting.timeGridFormatDateStringForSlot(availability.start_time, tempTimezone)
                            } else {
                                return null;
                            }
                        }).filter(Boolean);
                        setSelectedSlots(new Set(tempAvailabilities));
                    };
                }
                else {
                    alert.show("Fill out the Session Details first.", { type: 'error' })
                }
                setLoadingMissionEvent(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getMissionEvents();

    }, [])

    // Create the mission and move to the next page.
    async function updateSchedulingDetails({ timezoneData = timezone, noticeData = notice, bufferData = buffer, selectedSlotsData = Array.from(selectedSlots) } = {}) {
        console.log("Updating server with data:", selectedSlotsData);
        const result = await MissionEventsAPI.update(missionId, timezoneData, noticeData, bufferData, selectedSlotsData, navigate);

        if (result.success) {
            // alert.show("Scheduling details updated", { type: 'success' })
        } else {
            alert.show(result.error, { type: 'error' })
        }
        setSubmitInProcess(false);
    }

    function onClickBack() {
        navigate(props.backPath, { state: { missionId: missionId } })
    }
    function onClickNext(event) {
        event.preventDefault();

        if (selectedSlots.size == 0) {
            alert.show("Please select some availability", { type: 'error' })
            return;
        }
        updateSchedulingDetails();
        if (props.savePath) {
            navigate(props.savePath, { state: { missionId: missionId } });
        } else if (props.saveAction) {
            props.saveAction();
        }
    }

    function onChangeTimezone(e) {
        setTimezone(e.target.value);
        updateSchedulingDetails({ timezoneData: e.target.value });
    }
    function onChangeNotice(e) {
        setNotice(e.target.value);
        updateSchedulingDetails({ noticeData: e.target.value });
    }
    function onChangeBuffer(e) {
        setBuffer(e.target.value);
        updateSchedulingDetails({ bufferData: e.target.value });
    }

    // Create a debounced version of the update function
    // This will only update the server every 500ms
    const updateServerForSlots = useCallback(
        _.debounce(updateSchedulingDetails, 500), [] // 500ms debounce
    );

    // When the selected slots change, update the server
    // This will only update the server every 500ms
    function onChangeSelectedSlots(newSelectedSlots) {
        setSelectedSlots(newSelectedSlots);
        updateServerForSlots({ selectedSlotsData: Array.from(newSelectedSlots) });
    }






    return (
        <>
            <div className="extra-gap-primary" >
                <CreateMissionHeaderAndTitleRow title={"Scheduling"} subtitle="Tell us when to schedule sessions. Provide your availability for at least the next week. We recommend providing availability for at least two weeks. Click a time to indicate your availability, or drag to select multiple time slots." price={price} totalPrice={totalPrice} hidePrice={true} />
                <AvailabilityCalendar
                    onChangeTimezone={onChangeTimezone} timezone={timezone}
                    onChangeNotice={onChangeNotice} notice={notice}
                    onChangeBuffer={onChangeBuffer} buffer={buffer}
                    missionLength={missionLength}
                    selectedSlots={selectedSlots}
                    setSelectedSlots={onChangeSelectedSlots}
                    loadingMissionEvent={loadingMissionEvent}
                />
            </div>
            <CreationFooter buttonText={props.saveText}
                onClickBack={onClickBack} onClickSubmit={onClickNext}
                submitLoading={submitInProcess}
            />
        </>

    )
}


export default Scheduling;